export default __webpack_public_path__ + "static/media/pendingExtn.58c0bec6.svg";